import React from "react"

import Button from "../../../../design-system/button"
import Header from "../../../../design-system/header"
import OptimizedImage from "../../../../shared-components/optimized-image"
import useBreakpoint from "../../../../utils/hooks/use-breakpoint"
import { Image } from "../../types"
import * as styles from "./index.module.scss"

export type Props = {
  title: string
  image: Image | null
  linkText: string
  linkUrl: string
}

const CallToAction = ({ image, linkText, linkUrl, title }: Props) => {
  const { isSmallBreakpoint } = useBreakpoint()

  const BACKGROUND_SHAPES_SLUG = isSmallBreakpoint
    ? "1735307642-blog-cta-background-circle"
    : "1735306653-blog-cta-background-shapes"

  return (
    <div className={`blog-call-to-action ${styles.container}`}>
      <div className={styles.textContainer}>
        <Header textColor="white" as="h4" variant="3">
          {title}
        </Header>
        <Button
          as="a"
          href={linkUrl}
          trackingProperties={{
            buttonName: "blog-article-cta",
            buttonLocation: "body",
            buttonPosition: 1,
          }}
        >
          {linkText}
        </Button>
      </div>
      {image && (
        <div className={styles.imageBox}>
          <OptimizedImage
            src={image.url}
            loading="eager"
            alt={image.alt}
            height="92"
            width="263"
            preset="editorial"
          />
        </div>
      )}
      <OptimizedImage
        className={styles.backgroundShapes}
        src={`https://www.datocms-assets.com/85985/${BACKGROUND_SHAPES_SLUG}.png`}
        alt="background shapes"
        preset="graphic"
      />
    </div>
  )
}

export default CallToAction
